export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(')', ') ');
};
